<div class="dashboard-page">
    <!-- ── Notice + book closure month selector ──────────────── -->
    <div class="dashboard-notice">
        <span class="notice-label">
            The dashboard currently displays the book closure data for
        </span>
        <select
            class="month-select"
            [(ngModel)]="selectedBookClosureDetail"
            [compareWith]="compareBookClosure"
            (ngModelChange)="onBookClosureChange()"
        >
            <option *ngFor="let item of bookClosureDetails" [ngValue]="item">
                {{ item.month }}
            </option>
        </select>
    </div>

    <!-- ── Row 1: Stats panels ─────────────────────────────── -->
    <div class="dashboard-container">
        <div class="dashboard-panel" *ngFor="let panel of panels">
            <div class="panel-header">
                <div class="panel-title">
                    <svg
                        class="panel-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path [attr.d]="panel.iconPath"></path>
                    </svg>
                    <span class="panel-title-text">{{ panel.title }}</span>
                </div>
            </div>

            <div class="panel-body" *ngIf="!loadingMain">
                <div class="stat-item" *ngFor="let stat of panel.stats">
                    <div class="stat-label">
                        <span class="dot" [ngClass]="stat.dotClass"></span>
                        {{ stat.label }}
                    </div>
                    <div class="stat-value" [ngClass]="stat.colorClass">
                        {{ formatValue(stat.value) }}
                    </div>
                </div>
            </div>
            <div class="panel-body skeleton-body" *ngIf="loadingMain">
                <div class="skeleton-stat" *ngFor="let s of [1, 2, 3]">
                    <div class="skeleton-line skeleton-sm"></div>
                    <div class="skeleton-line skeleton-lg"></div>
                </div>
            </div>
        </div>
    </div>

    <!-- ── Row 2: Allocation Overview panels ──────────────── -->
    <div class="dashboard-container">
        <ng-container *ngIf="!loadingMain">
            <div class="overview-card" *ngFor="let ov of allocationOverviews; let i = index">
                <div class="overview-header">
                    <span class="overview-title"
                        >{{ ov.centerLabel }} Overview</span
                    ><span class="overview-subtitle" *ngIf="i === 2"> (Last 6-Month Trend) </span>
                </div>

                <!-- Donut chart for Component and Final Assembly -->
                <div class="donut-wrapper" *ngIf="i < 2">
                    <svg viewBox="0 0 100 100" class="donut-svg">
                        <g transform="rotate(-90 50 50)">
                            <circle
                                *ngFor="let seg of ov.segments"
                                cx="50"
                                cy="50"
                                r="35"
                                fill="none"
                                [attr.stroke]="seg.color"
                                stroke-width="14"
                                [attr.stroke-dasharray]="seg.dasharray"
                                [attr.stroke-dashoffset]="seg.dashoffset"
                            >
                                <title>
                                    {{ seg.label }}:
                                    {{ formatValue(seg.value) }}
                                </title>
                            </circle>
                        </g>
                        <!-- Center labels -->
                        <text
                            x="50"
                            y="43"
                            text-anchor="middle"
                            class="donut-text-top"
                        >
                            Total
                        </text>
                        <text
                            x="50"
                            y="52"
                            text-anchor="middle"
                            class="donut-text-mid"
                        >
                            {{ ov.centerLabel }}
                        </text>
                        <text
                            x="50"
                            y="71"
                            text-anchor="middle"
                            class="donut-text-val"
                        >
                            {{ formatValue(ov.total) }}
                        </text>
                    </svg>
                </div>

                <!-- Stacked bar chart for Simulation monthly data -->
                <div class="bar-chart-wrapper" *ngIf="i === 2">
                    <ng-container *ngIf="simulationBarEntries.length > 0; else noSimData">
                        <svg
                            [attr.viewBox]="simulationBarViewBox"
                            class="bar-chart-svg"
                            preserveAspectRatio="xMidYMid meet"
                        >
                            <g *ngFor="let entry of simulationBarEntries; let bi = index">
                                <rect
                                    *ngFor="let seg of entry.segments"
                                    [attr.x]="bi * 50 + 11"
                                    [attr.y]="seg.y"
                                    width="28"
                                    [attr.height]="seg.height"
                                    [attr.fill]="seg.color"
                                    rx="2"
                                >
                                    <title>{{ seg.label }}: {{ formatValue(seg.value) }}</title>
                                </rect>
                                <!-- total value above each bar -->
                                <text
                                    [attr.x]="bi * 50 + 25"
                                    [attr.y]="+entry.topY - 3"
                                    text-anchor="middle"
                                    class="bar-value"
                                >{{ formatValue(entry.total) }}</text>
                                <text
                                    [attr.x]="bi * 50 + 25"
                                    y="128"
                                    text-anchor="middle"
                                    class="bar-label"
                                >{{ entry.label }}</text>
                            </g>
                        </svg>
                        <!-- legend -->
                        <div class="bar-legend">
                            <span class="bar-legend-item">
                                <span class="bar-legend-dot" style="background:#5b9bd5"></span>SEU
                            </span>
                            <span class="bar-legend-item">
                                <span class="bar-legend-dot" style="background:#6bba8a"></span>SLA
                            </span>
                            <span class="bar-legend-item">
                                <span class="bar-legend-dot" style="background:#e57373"></span>Errors
                            </span>
                        </div>
                    </ng-container>
                    <ng-template #noSimData>
                        <span class="bar-no-data">No monthly data</span>
                    </ng-template>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="loadingMain">
            <div class="overview-card" *ngFor="let panel of panels">
                <div class="overview-header">
                    <span class="overview-title"
                        >{{ panel.title }} Overview</span
                    >
                </div>
                <div class="donut-wrapper skeleton-donut-wrapper">
                    <div class="skeleton-donut"></div>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- ── Row 3: Allocation by Unit ──────────────────────── -->
    <div class="dashboard-container">
        <ng-container *ngIf="!loadingMain">
            <div class="unit-card" *ngFor="let section of allocationByUnits">
                <div class="unit-card-header">
                    <span class="unit-card-title">{{ section.title }}</span>
                </div>

                <table class="unit-table">
                    <thead>
                        <tr>
                            <th class="col-unit">Unit</th>
                            <th class="col-num">Produced</th>
                            <th class="col-num">Allocated</th>
                            <th class="col-num">Flow Errors</th>
                            <th class="col-status">Status</th>
                            <th class="col-arrow"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="unit-row" *ngFor="let row of section.rows">
                            <td class="col-unit">
                                <div class="unit-name-cell">
                                    <span class="unit-icon-wrap">
                                        <svg
                                            class="unit-row-icon"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="1.8"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        >
                                            <path
                                                [attr.d]="row.iconPath"
                                            ></path>
                                        </svg>
                                    </span>
                                    <span class="unit-name">{{
                                        row.name
                                    }}</span>
                                </div>
                            </td>
                            <td class="col-num stat-orange">
                                {{ formatValue(row.produce) }}
                            </td>
                            <td class="col-num stat-green">
                                {{ formatValue(row.allocated) }}
                            </td>
                            <td class="col-num stat-red">
                                {{ formatValue(row.errors) }}
                            </td>
                            <td class="col-status">
                                <div class="status-cell">
                                    <span
                                        class="dot"
                                        [ngClass]="
                                            row.status === 'Allocated'
                                                ? 'dot-green'
                                                : 'dot-red'
                                        "
                                    ></span>
                                    <span class="status-text">{{
                                        row.status
                                    }}</span>
                                </div>
                            </td>
                            <td
                                class="col-arrow"
                                (click)="navigateToAllocation(section, row)"
                            >
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                >
                                    <polyline
                                        points="9 18 15 12 9 6"
                                    ></polyline>
                                </svg>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>
        <ng-container *ngIf="loadingMain">
            <div class="unit-card" *ngFor="let i of [1, 2]">
                <div class="unit-card-header">
                    <div class="skeleton-line skeleton-title"></div>
                </div>
                <div class="skeleton-table">
                    <div class="skeleton-row" *ngFor="let r of [1, 2, 3, 4]">
                        <div class="skeleton-line skeleton-cell"></div>
                        <div class="skeleton-line skeleton-cell-sm"></div>
                        <div class="skeleton-line skeleton-cell-sm"></div>
                        <div class="skeleton-line skeleton-cell-sm"></div>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- Simulation Details -->
        <div
            class="unit-card"
            *ngIf="missingPartMarket1 && missingPartMarket1.length > 0"
        >
            <div class="unit-card-header">
                <span class="unit-card-title">Missing Simulation Material Prices  </span>
                <span class="unit-card-subtitle">(Last 30 Days Trend for the Current Day)</span>
            </div>

            <ng-container *ngIf="loadingSimDetails">
                <div class="skeleton-table">
                    <div class="skeleton-row" *ngFor="let r of [1, 2]">
                        <div class="skeleton-line skeleton-cell"></div>
                        <div class="skeleton-line skeleton-cell-sm"></div>
                    </div>
                </div>
            </ng-container>

            <table class="unit-table" *ngIf="!loadingSimDetails">
                <thead>
                    <tr>
                        <th class="col-unit">Market</th>
                        <th class="col-num">Total Missing Count</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="unit-row" *ngFor="let row of missingPartMarket1">
                        <td class="col-unit">
                            <div class="unit-name-cell">
                                <span class="unit-name">{{
                                    row.marketName
                                }}</span>
                            </div>
                        </td>
                        <td class="col-num stat-green">
                            {{ formatValue(row.totalCount) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
